import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-choose-phone-number',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatCardModule,
    MatRadioModule,
    RouterLink,
  ],
  templateUrl: './choose-phone-number.component.html',
  styleUrl: './choose-phone-number.component.scss',
})
export class ChoosePhoneNumberComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);

  phoneForm = this.fb.group({
    phoneNumber: ['', Validators.required],
  });

  phoneNumbers: string[] = [];

  ngOnInit(): void {
    this.accountService.twoFAUser$.subscribe((user) => {
      if (!user) {
        this.router.navigate(['/login']);
        return;
      }

      this.phoneNumbers = Array.isArray(user.phoneNumbers) ? user.phoneNumbers : [];

      if (this.phoneNumbers.length > 0) {
        this.phoneForm.patchValue({ phoneNumber: this.phoneNumbers[0] });
      }
    });
  }

  formatPhone(phone: string | null | undefined): string {
    if (!phone) return '';

    const digits = phone.replace(/\D/g, '');

    // US-style (11 digits starting with 1)
    if (digits.length === 11 && digits.startsWith('1')) {
      const area = digits.slice(1, 4);
      const prefix = digits.slice(4, 7);
      const line = digits.slice(7);

      return `+1 (${area}) ${prefix}-${line}`;
    }

    // fallback (in case something weird comes in)
    return phone;
  }

  onSubmit(): void {
    if (this.phoneForm.valid) {
      const selectedPhone = this.phoneForm.value.phoneNumber;

      this.accountService.getLoginCodeFor2FA(selectedPhone).subscribe({
        next: () => {
          this.route.queryParams.subscribe((params) => {
            this.router.navigate(['/verify-2fa'], { queryParams: params });
          });
        },
        error: () => {
          this.snackbar.error('Failed to send verification code');
        },
      });
    }
  }
}